/** The query parameter naming the draft the requisition wizard opens on. */
export const WIZARD_DRAFT_PARAM = 'draft';

/** The requisition wizard, opened on a draft that already exists. */
// @ai-generated 2026-09-29T09:54:18+00:00 by matthias.gessinger@synqony.com using Claude Opus 5.5 (1M context)
export function requisitionWizardPath(draftId: string): string {
    return `/requisitions/new?${new URLSearchParams({ [WIZARD_DRAFT_PARAM]: draftId }).toString()}`;
}
